import React, { memo } from 'react';

import { noop } from '~/core/scripts/utils';
import './SearchPresets.styl';

const SearchPresets = memo(({ presets, title, onClick = noop }) => {
  if (!presets || presets.length === 0) {
    return null;
  }

  return (
    <div className="search__presets">
      {title && <div className="search__presets-title">{title}</div>}
      <div className="search__presets-list">
        {presets.map(p => (
          <div key={`search__preset_${p.name}`} className="search__presets-preset" onClick={() => onClick(p)}>
            {p.name}
          </div>
        ))}
      </div>
    </div>
  );
});

SearchPresets.displayName = 'SearchPresets';

export default SearchPresets;
